import React from 'react';
import PopUp from '../../HOC/PopUp';

const NotEligiblePopup = ({ mobileNumber, onCloseClick }) => {
  return (
    <PopUp onClose={() => onCloseClick(false)}>
      <>
        <div class='modal-content'>
          <div class='modal-body clearfix'>
            <h3>Sorry, no cardless EMI offer found.</h3>
            <p>
              No cardless EMI offer found for "{mobileNumber}". You can try
              changing the mobile number.
            </p>
          </div>
        </div>
      </>
    </PopUp>
  );
};

export default NotEligiblePopup;
